import { Modal, ModalBody } from 'reactstrap';
import IAIcon from '../../../../assets/creation.png';
import IAIconGrowme from '../../../../assets/icon_iagrowme.png';

const IaInfoModal = (props) => {
  const { open, toggle, onClickStartIaSummary } = props;
  const onClickAction = () => {
    onClickStartIaSummary();
  };
  return (
    <Modal isOpen={open} toggle={toggle} size='lg'>
      <div className='gm-modal-header'>
        <button type="button" className="btn-close" aria-label="Close" onClick={toggle} />
      </div>
      <ModalBody>
        <div className='gm-ia-notification-container'>
          <p>NUEVA FUNCIÓN</p>
          <img src={IAIconGrowme} alt="icon" />
          <h3>Resumen con Inteligencia Artificial en GrowMe</h3>
          <p className="description">
            ✨ Agiliza el análisis de talento con nuestra función de IA.
            <br />
            Ahora puedes ver la información clave de
            <br />
            evaluaciones de tus colaboradores.
          </p>
          <button
            className="gm-btn-ia"
            type="button"
            onClick={onClickAction}>
            Ver Resumen IA
            <img src={IAIcon} alt="IA icon" />
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default IaInfoModal;
